export enum OperationalDemandTypeEnum {
  CANCEL_ORDER = 1,
  DELETE_PAYMENT = 2,
  CHANGE_PAYMENT_TYPE_TO_CASH = 3,
  CHANGE_PAYMENT_TYPE_TO_CREDIT_CARD = 4,
  MODIFY_ORDER = 5,
  GRANT_ROLE_CODE_TO_USER = 10,
}
